export default "__VITE_ASSET__47d85ea6__"